import React, { useContext, useEffect } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { Card, Col, Input, Row, Select, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { Form } from '@ant-design/compatible';

// import '@ant-design/compatible/assets/index.css';


import { getPoisDropdownAction } from '../../../../actions/AppCms/PoiActions';
import { getPoiGroupsAction } from '../../../../actions/AppCms/PoiGroupActions';
import UserContext from '../../../layout/UserContext';
import checkPermission from '../../../../components/Authorization/Util';

const { Option } = Select;

const General = ({ reportData, form }) => {
  const dispatch = useDispatch();

  const { poiGroups, poisDropdown } = useSelector(store => ({
    poiGroups: store.poiGroupReducer.poiGroups,
    poisDropdown: store.poiReducer.poisDropdown,
  }));

  useEffect(() => {
    dispatch(getPoisDropdownAction({ notAssignedToBeacon: true }));
    dispatch(getPoiGroupsAction({ notAssignedToBeacon: true }));

  }, []);

  const handlePOISelection = value => {


    if (value === undefined) {
      form.setFieldsValue({
        pointOfInterestId: null,
      });
    }

    if (value && value > 0) {
      form.setFieldsValue({
        pointOfInterestId: value,
        groupId: null,
      });
    }
  };

  const handlePOIGroupSelection = value => {


    if (value === undefined) {
      form.setFieldsValue({
        groupId: null,
      });
    }

    if (value && value > 0) {
      form.setFieldsValue({
        pointOfInterestId: null,
        groupId: value,
      });
    }
  };

  const { getFieldDecorator } = form;

  const value = useContext(UserContext);
  // const value = this.context;
  const disable = !checkPermission(value, 'appcms', 'write');
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading

    (<div>
      <Row>
        <Col span={13}>
          <Card bordered={false}>
            <Form.Item label="Unique ID">
              {getFieldDecorator('uniqueId', {
                rules: [],
                initialValue:
                  reportData && reportData.uniqueId
                    ? reportData.uniqueId
                    : undefined,
              })(<Input disabled={true} />)}
            </Form.Item>
            <Form.Item label="MAC Address">
              {getFieldDecorator('mac', {
                rules: [],
                initialValue:
                  reportData && reportData.mac ? reportData.mac : undefined,
              })(<Input disabled={true} />)}
            </Form.Item>
            <Form.Item
              label={
                <span>
                  POI&nbsp;
                  <Tooltip title="Select either a POI or a POI group.">
                    <InfoCircleOutlined />
                  </Tooltip>
                </span>
              }
            >
              {getFieldDecorator('pointOfInterestId', {
                rules: [],
                //  initialValue:
                //    reportData &&  reportData.poiList && reportData.poiList.length>0
                //      ? reportData.poiList[0].id
                //      : undefined,
              })(
                <Select
                  allowClear
                  showSearch
                  filterOption
                  optionFilterProp="children"
                  onChange={val => handlePOISelection(val)}
                  disabled={disable}
                  style={{ width: '100%' }}

                >
                  {poisDropdown.map(item => (
                    <Option key={item.id} value={item.id}>
                      {item.title}
                    </Option>
                  ))}
                </Select>,
              )}
            </Form.Item>
            <Form.Item
              label={
                <span>
                  POI Group&nbsp;
                  <Tooltip title="Select either a POI or a POI group.">
                    <InfoCircleOutlined />
                  </Tooltip>
                </span>
              }
            >
              {getFieldDecorator('groupId', {
                rules: [],
                //  initialValue:
                //    reportData && reportData.pointOfInterestGroup
                //      ? reportData.pointOfInterestGroup.id
                //      : undefined,
              })(
                <Select
                  allowClear
                  showSearch
                  filterOption
                  optionFilterProp="children"
                  onChange={val => handlePOIGroupSelection(val)}
                  disabled={disable}
                  style={{ width: '100%' }}
                >
                  {poiGroups.map(item => (
                    <Option key={item.id} value={item.id}>
                      {item.title}
                    </Option>
                  ))}
                </Select>,
              )}
            </Form.Item>

            {/* <Form.Item label="Beacon Sensitivity Range">
                     {getFieldDecorator('beaconSensitivityRange', {
                       rules: [],
                       initialValue:
                         reportData && reportData.data.beaconSensitivityRange
                           ? [reportData.data.beaconSensitivityRange.min,reportData.data.beaconSensitivityRange.max]
                           : undefined,
                     })(
                       <Slider range   marks={{
                        '-300': 'Low',
                        '-200': 'Medium',
                        '-100': 'High',
                        
                      }}
                      defaultValue={[-300, -100]}  min={-300}  max={-100}/>,
                     )}
                   </Form.Item> */}
          </Card>
        </Col>
        <Col span={11}>
          {/* <Card bordered={true} title={'Assigned POIs'}>
          <List
            dataSource={reportData.poiList}
            renderItem={item => (
              <List.Item key={item.id}>
                <List.Item.Meta
                  title={item.title}
                />
   
              </List.Item>
            )}
          >
          </List>
          </Card> */}
        </Col>
      </Row>
    </div>)
  );
};

General.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  form: PropTypes.object,
  reportData: PropTypes.object,
};

General.contextType = UserContext;

function mapStateToProps({ poiReducer, poiGroupReducer }) {
  const { poiGroups } = poiGroupReducer;
  const { poisDropdown } = poiReducer;
  return {
    poiGroups,
    poisDropdown,
  };
}

export default connect(mapStateToProps, {
  getPoisDropdownAction,
  getPoiGroupsAction,
})(General);
